import { getActiveOrganizations } from '../../../../backend/features/mission';
import { requireOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
/**
 * Generates a filter configuration for fetching missions
 * based on authorized mission type IDs and organizations the user has permission to manage.
 *
 * Conditions for managing missions by mission type:
 *  - The user is authorized to manage the mission type via the 'Mission Type' classifier configuration.
 *  - The mission is not public.
 *  - The user has the 'manage-organization' permission for at least one organization the mission is shared with.
 *
 * @param {UserState} userState - Object that contains user related information.
 * @returns {Filter<MissionColumns>[]} Array of filter conditions to apply when querying missions.
 */
export const getAuthorizedMissionTypesFilter = (userState) => {
    const authorizedMissionTypesId = userState.authorizedMissionTypeIds;
    const accountActiveOrganizationIds = getActiveOrganizations(userState);
    const organizationsWithManagePermission = accountActiveOrganizationIds.filter((organization) => requireOrgPermission(userState, organization, 'manage-organization'));
    return [
        {
            column: 'typeId',
            op: 'in',
            value: authorizedMissionTypesId,
        },
        {
            column: 'public',
            op: '=',
            value: false,
        },
        {
            column: 'organizationSharing',
            op: 'overlap',
            value: organizationsWithManagePermission,
        },
    ];
};
